import React, { Component } from 'react';
import { Alert, Glyphicon } from 'react-bootstrap';

import '../styles/Notifications.css';

class Notifications extends Component {
  render() {
    const { alerts, isInvoking, invokingMessage, onDismissAlert, newUser } = this.props;
    return (
      <div>
        {isInvoking ?
          <Alert bsStyle="success" className="fetching">
            <Glyphicon glyph="refresh" className="spinning" />{invokingMessage}
          </Alert>
          :
          null
        }
        {alerts.map((alert) => (
            <Alert bsStyle={alert.style} key={alert.id} onDismiss={() => onDismissAlert(alert.id)}>
              {alert.message}
            </Alert>
          )
        )}
        {newUser ?
          <Alert bsStyle="warning" className="new-user">
            First time user. Your account is being created. Some functionality may not work right away.
          </Alert>
          :
          null
        }
      </div>
    );
  }
}

export default Notifications;